import React, { useEffect, useState } from 'react';

import { Button, Flex, Form, Modal } from 'antd';
import Title from 'antd/es/typography/Title';
import { Dayjs } from 'dayjs';
import { t as globalT } from 'i18next';
import { useTranslation } from 'react-i18next';

import { useNotification } from 'segments/hooks/useNotification';

import { WeekPicker } from 'shared/FormItems';

import { GroupAttendance } from 'features/adminOperations/components/GroupAttendance';
import { useDeleteCoachBookingMutation } from 'features/coachesBooking';

interface Props {
  isModalOpen: boolean;
  handleCancel: () => void;
  bookingId?: number;
}

type FormData = { deleteUntil?: Dayjs }

export const BookedCoachDetailModal = ({ isModalOpen, handleCancel, bookingId }: Props) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'booked-court.titles' });
  const [form] = Form.useForm<FormData>();
  const [deleteBooking, { isSuccess: isBookingDeleted, error }] = useDeleteCoachBookingMutation();
  const [hasRecordedAttendance, setHasRecordedAttendance] = useState(false);

  useEffect(() => {
    setHasRecordedAttendance(false);
  }, [bookingId]);

  const onFinish = ({ deleteUntil }: FormData) => {
    if (bookingId !== undefined) {
      deleteBooking({
        bookingId,
        ...(deleteUntil && { deleteUntil: deleteUntil.format('YYYY-MM-DD') })
      });
    }
  };

  useNotification({
    error,
    isSuccess: isBookingDeleted,
    onSuccess: () => handleCancel(),
  });

  return (
    <Modal
      open={isModalOpen}
      onCancel={handleCancel}
      destroyOnClose
      footer={null}
    >
      {isModalOpen && bookingId !== undefined && (
        <GroupAttendance bookingId={bookingId} bookingKind="coach-bookings" onRecordedChange={setHasRecordedAttendance} />
      )}
      {!hasRecordedAttendance && (
        <Form
          name="basic"
          layout="vertical"
          form={form}
          onFinish={onFinish}
          autoComplete="off"
          className="edit-user__form"
          style={{ marginTop: '30px' }}
        >
          <Title level={5}>{t('delete')}</Title>
          <Flex justify='space-between' align='end'>
            <WeekPicker
              formItemsProps={{
                name: 'deleteUntil',
                label: t('delete-until')
              }}
            />
            <Button type="primary" danger htmlType="submit">{globalT('table.delete')}</Button>
          </Flex>
        </Form>
      )}
    </Modal >
  );
};
